import { isValidHex } from './theme/theme';

const colors = {
  white: '#ffffff',
  black: '#000000',
  red: '#f93e3f',
  orange: '#ff8940',
  lightBlue: '#65baff',
  blue5: '#89ceda',
  blue10: '#65baff',
  blue50: '#007490',
  green10: '#b3e5e2',
  green20: '#81d5cf',
  green30: '#4bc3bb',
  green40: '#00ab9f',
  green50: '#00948a',
  gray10: '#fafafa',
  gray20: '#c3c3c3',
  gray50: '#979797',
  gray60: '#747474',
  gray70: '#6C727F',
  gray80: '#4a4a4a',
  brand: isValidHex(ADV.info.customColor) ? ADV.info.customColor : null,
};

const fonts = {
  sansSerif: 'Open Sans',
  sansSerifSecondary: 'Mukta',
  serif: 'Playfair Display',
};

export default {
  breakpoints: ['576px', '768px', '992px', '1200px'],
  space: [0, 4, 8, 12, 16, 20, 24, 28, 32, 36, 40, 44, 48, 52, 56, 60, 64],
  fontSizes: [12, 14, 16, 18, 20, 22, 24, 28, 30, 32, 34, 36, 38, 40, 42, 44],
  fonts,
  fontWeights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
  lineHeights: ['1em', '1.25em', '1.5em', '1.75em', '2em'],
  letterSpacings: [0, '0.1em', '0.2em', '0.3em'],
  colors,
  borders: {
    gray: '1px solid #979797',
    lightGray: '1px solid #dedede',
    green40: `1px solid ${colors.green40}`,
  },
  shadows: {
    small: '0 0 8px 0 rgba(0, 0, 0, 0.15)',
    big: '0 0 32px 0 rgba(0, 0, 0, 0.15)',
    drop: '0 1px 3px 0 rgba(127, 127, 127, 0.5)',
  },
  radii: {
    small: 4,
    medium: 8,
    big: 16,
    round: '2em',
  },
  maxWidths: {
    desktopContainer: 1024,
  },
  grid: {
    gutter: 16,
  },
  borderRadius: '4px',
};
